module.exports = __webpack_public_path__ + "img/ship-for-success.400535fb.svg";